.banner {
  margin-left: -2rem;
  margin-right: -2rem;
}

.banner img {
  display: block;
  width: 100%;
  height: auto;
}
